/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { KonturFocusIcon16Light } from './KonturFocusIcon16Light';
import { KonturFocusIcon16Regular } from './KonturFocusIcon16Regular';
import { KonturFocusIcon16Solid } from './KonturFocusIcon16Solid';
import { KonturFocusIcon20Light } from './KonturFocusIcon20Light';
import { KonturFocusIcon20Regular } from './KonturFocusIcon20Regular';
import { KonturFocusIcon20Solid } from './KonturFocusIcon20Solid';
import { KonturFocusIcon24Regular } from './KonturFocusIcon24Regular';
import { KonturFocusIcon24Solid } from './KonturFocusIcon24Solid';
import { KonturFocusIcon32Regular } from './KonturFocusIcon32Regular';
import { KonturFocusIcon64Regular } from './KonturFocusIcon64Regular';
var sizes = {
    16: {
        light: KonturFocusIcon16Light,
        regular: KonturFocusIcon16Regular,
        solid: KonturFocusIcon16Solid,
    },
    20: {
        light: KonturFocusIcon20Light,
        regular: KonturFocusIcon20Regular,
        solid: KonturFocusIcon20Solid,
    },
    24: {
        regular: KonturFocusIcon24Regular,
        solid: KonturFocusIcon24Solid,
    },
    32: {
        regular: KonturFocusIcon32Regular,
    },
    64: {
        regular: KonturFocusIcon64Regular,
    },
};
export var KonturFocusIcon = forwardRef('KonturFocusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
